import { useEffect, useRef } from 'react';
import { Subject, takeUntil } from 'rxjs';
import type { ActiveRecordRef } from '../components/active-record/active-record.component';
import { getActiveRecordReference } from '../services/active-record.service';

const useActiveRecordRef = () => {
  const activeRecordReference = useRef<ActiveRecordRef | null>(null);
  const destroySubject = useRef(new Subject<void>());

  useEffect(() => {
    getActiveRecordReference()
      .pipe(takeUntil(destroySubject.current))
      .subscribe((reference) => {
        activeRecordReference.current = reference;
      });

    return () => {
      destroySubject.current.next();
      destroySubject.current.complete();
    };
  }, []);

  return {
    activeRecordReference,
  };
};

export default useActiveRecordRef;
